import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { BehaviorSubject, of, switchMap, tap } from 'rxjs';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';
import { CustomFieldsService } from '../custom-fields.service';
import { CustomFieldEntity } from 'src/app/shared/models/custom-field-entity';

@Component({
    selector: 'nova-custom-field-viewer',
    templateUrl: './custom-field-viewer.component.html',
    styleUrls: ['./custom-field-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomFieldViewerComponent {
    @Input() wrapWithCard = true;
    isLoading = true;
    displayedColumns: string[] = ['name', 'value'];
    featureFlag = FeatureFlag;
    service = inject(CustomFieldsService);
    subject$ = new BehaviorSubject<CustomFieldEntity>(null);
    values$ = this.subject$.pipe(
        switchMap((entity) => {
            return entity ? this.service.getValues(entity).pipe(tap(() => (this.isLoading = false))) : of([]);
        })
    );

    constructor() {}

    @Input()
    set entity(entity: CustomFieldEntity) {
        this.subject$.next(entity);
    }
}
